import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PetsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pets"}/>
}
